import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlService } from 'src/app/services/url.service';

@Component({
  selector: 'app-custom-breadcrumb',
  templateUrl: './custom-breadcrumb.component.html',
  styleUrls: ['./custom-breadcrumb.component.scss']
})
export class CustomBreadcrumbComponent implements OnInit {
  @Input() data: any;
  currentUrl: string = '';
  customBreadcrumb : any[];
  claimId: any;
  radProgId: any;
  constructor(
    private urlService: UrlService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.currentUrl = window.location.href;
    this.setCustomBreadCrumb();
    if(this.data['medicalConditionValue']) {
      this.setCustomBreadCrumbForAudiogram();
      this.setCustomBreadcrumbForRadiologicalProgression()
      this.setCustomBreadcrumbForExposure();
      this.setCustomBreadcrumbForBreachofDuty();
      this.setCustomBreadCrumbForImmunoProfile()
    }
  }

  public setCustomBreadCrumbForImmunoProfile() {
    if (this.currentUrl.includes(this.data['medicalConditionValue']+'/immunohistology-profiling/edit-profile/')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Edit Profile',
          url : '#',
          isActive: false
        }
      ]
    }

    if (this.currentUrl.includes(this.data['medicalConditionValue']+'/immunohistology-profiling/create-profile/')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Create New Profile',
          url : '#',
          isActive: false
        }
      ]
    }
  }

  public setCustomBreadCrumbForAudiogram() {
    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/investigation/edit-audiometry')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Medical Records ',
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId'])+'/medical',
          isActive: true
        },
        {
          label : this.data['audiometryType'],
          url : '#/nihl/investigation/audiogram-analyse/'+ encodeURIComponent(this.data['claimId']) + '/' + encodeURIComponent(this.data['taskId']) + '/'
           + this.data['testId'],
          isActive: true
        },
        {
          label : 'Edit Audiometry Form',
          url : '#',
          isActive: false
        }
      ]
    }

    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/investigation/create-audiometry/')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        // {
        //   label : 'Tasks ',
        //   url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
        //   isActive: true
        // },
        {
          label : 'Create Audiometry',
          url : '#',
          isActive: false
        }
      ]
    }

    if (this.currentUrl.includes(this.data['medicalConditionValue']+'/investigation/audiogram-analyse')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Medical Records ',
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId'])+'/medical',
          isActive: true
        },
        // {
        //   label : this.data['audiometryType'] ,
        //   url : '#/nihl/investigation/audiogram-analyse/'+ encodeURIComponent(this.data['claimId']) + '/' + encodeURIComponent(this.data['taskId']) + '/'
        //    + this.data['testId'],
        //   isActive: true
        // },
        {
          label : this.data['audiometryType'],
          url : '#',
          isActive: false
        }
      ]
    }

    if (this.currentUrl.includes(this.data['medicalConditionValue']+'/outcome/assess-disability/hearing-loss')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Outcome ',
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId'])+'/outcome',
          isActive: true
        },
        {
          label : 'Assess Disability Hearing Loss ',
          url : '#',
          isActive: false
        },
      ]
    }

    if (this.currentUrl.includes(this.data['medicalConditionValue']+'/outcome/quantum/historical-compensations')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Outcome ',
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId'])+'/outcome',
          isActive: true
        },
        {
          label : 'Quantum Historical Compensations ',
          url : '#',
          isActive: false
        },
      ]
    }

    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/limitation/advice')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        // {
        //   label : 'Tasks ',
        //   url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
        //   isActive: true
        // },
        {
          label : 'Limitation',
          url : '#',
          isActive: false
        }
      ]
    }

    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/investigation/compare-audiograms/')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']),
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Compare Audiogram',
          url : '#',
          isActive: false
        }
      ]
    } 

   
  }

  public setCustomBreadCrumb() {
    if (this.currentUrl.includes('claimForm/')) {
        this.customBreadcrumb = [
          {
            label: 'Claims',
            url: '#/',
            isActive: true
          },
          {
            label: 'Edit Claim',
            url: '#',
            isActive: false
          }
        ];
      } else {
        this.customBreadcrumb = [
          {
            label: 'Claims',
            url: '#/',
            isActive: true
          },
          {
            label: 'New Claim',
            url: '#',
            isActive: false
          }
        ];
      }
  

    if (this.currentUrl.includes('claimDetail')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']),
          url : '#',
          isActive: false
        }
      ]
    }

    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/apportionment/assess-contribution-to-costs')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Edit Claim',
          url : '#',
          isActive: false
        }
      ]
    }

    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/investigation/outline-exposure/add/')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Outline Exposure ',
          url : '#/nihl/investigation/outline-exposure/' + encodeURIComponent(this.data['claimId']) + '/' + encodeURIComponent(this.data['taskId']),
          isActive: true
        },
        {
          label : 'Add Exposure',
          url : '#',
          isActive: false
        }
      ]
    } else 
    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/investigation/outline-exposure')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Outline Exposure',
          url : '#',
          isActive: false
        }
      ]
    } 

       
  }

  public setCustomBreadcrumbForRadiologicalProgression() {

    if (this.currentUrl.includes(this.data['medicalConditionValue']+'/radiological-progression/create-chart/')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Medical Records ',
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId'])+'/medical',
          isActive: true
        },
        {
          label : 'Create New Chart',
          url : '#',
          isActive: false
        }
      ]
    } 

    if (this.currentUrl.includes(this.data['medicalConditionValue']+'/radiological-progression/view-chart')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Medical Records ',
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId'])+'/medical',
          isActive: true
        },
        // {
        //   label : this.data['radProgName'] +' ',
        //   url : '#/'+this.data['medicalConditionValue']+'/radiological-progression/view-chart/'+encodeURIComponent(this.data['claimId']) +'/'+this.data['radProgId'],
        //   isActive: true
        // },
        {
          label : this.data['chartTitle'],
          url : '#',
          isActive: false
        }
      ]
    }

    if (this.currentUrl.includes(this.data['medicalConditionValue']+'/radiological-progression/edit-chart/')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Medical Records ',
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId'])+'/medical',
          isActive: true
        },
        // {
        //   label : this.data['radProgName'] +' ',
        //   url : '#/'+this.data['medicalConditionValue']+'/radiological-progression/view-chart/'+encodeURIComponent(this.data['claimId']) +'/'+this.data['radProgId'],
        //   isActive: true
        // },
        {
          label : 'Edit Chart',
          url : '#',
          isActive: false
        }
      ]
    }
  }

  public capitalizeFirstLetter(str: any) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  public setCustomBreadcrumbForBreachofDuty() {
    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/investigation/establish-breach-of-duty')) {
      this.customBreadcrumb = [
        { 
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Breach of Duty',
          url : '#',
          isActive: false
        }
      ]
    }
  }

  public setCustomBreadcrumbForExposure() { 
    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/exposure/outline-exposure-to-dust/editActivity')) {
      this.customBreadcrumb = [
        { 
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Edit Exposure',
          url : '#',
          isActive: false
        }
      ]
    } else 
    if(this.currentUrl.includes(this.data['medicalConditionValue']+'/exposure/outline-exposure-to-dust/addActivity')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Add Exposure',
          url : '#',
          isActive: false
        }
      ]
    } else 
    if (this.currentUrl.includes(this.data['medicalConditionValue']+'/exposure/outline-exposure-to-dust/')) {
      this.customBreadcrumb = [
        {
          label : 'Claims' ,
          url : '#/',
          isActive: true
        },
        {
          label : this.capitalizeFirstLetter(this.data['claimantName']) ,
          url : '#/claimDetail/'+encodeURIComponent(this.data['claimId']),
          isActive: true
        },
        {
          label : 'Exposure',
          url : '#',
          isActive: false
        }
      ]
    } 
  }

}
